import { useState } from 'react';
import {
  ArrowUpRight,
  CheckCircle2,
  Clock3,
  Mail,
  MapPin,
  Phone,
} from 'lucide-react';
import { useForm, ValidationError } from '@formspree/react';

import SectionHeading from './SectionHeading.jsx';
import { siteConfig } from '../data/siteData.js';

const initialForm = {
  name: '',
  email: '',
  phone: '',
  goal: 'Személyi edzés',
  message: '',
  privacy: false,
};

export default function Contact() {
  const [state, handleSubmit] = useForm('xqerwozn');
  const [form, setForm] = useState(initialForm);

  const update = (event) => {
    const { name, value, type, checked } = event.target;

    setForm((current) => ({
      ...current,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  return (
    <section className="section contact-section" id="kapcsolat">
      <div className="contact-noise" aria-hidden="true" />

      <div className="container contact-layout">
        <div className="contact-copy">
          <SectionHeading
            eyebrow="Kezdjük el"
            title="Az első lépés csak egy beszélgetés."
            text="Írd le röviden, miben szeretnél fejlődni. Visszajelzek, és megnézzük, melyik együttműködés lenne számodra a legjobb."
          />

          <div className="contact-promise">
            <CheckCircle2 size={22} />

            <div>
              <strong>Ingyenes, kötelezettségmentes konzultáció</strong>
              <span>
                Nincs nyomásgyakorlás, csak tiszta következő lépések.
              </span>
            </div>
          </div>

          <div className="contact-details">
            <a href={`tel:${siteConfig.contact.phoneHref}`}>
              <Phone size={20} />

              <div>
                <span>Telefon</span>
                <strong>{siteConfig.contact.phone}</strong>
              </div>
            </a>

            <a href={`mailto:${siteConfig.contact.email}`}>
              <Mail size={20} />

              <div>
                <span>E-mail</span>
                <strong>{siteConfig.contact.email}</strong>
              </div>
            </a>

            <div>
              <MapPin size={20} />

              <div>
                <span>Helyszín</span>
                <strong>{siteConfig.location}</strong>
              </div>
            </div>

            <div>
              <Clock3 size={20} />

              <div>
                <span>Válaszidő</span>
                <strong>Általában 1 munkanapon belül</strong>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-form-card">
          <div className="contact-form-header">
            <span>INGYENES KONZULTÁCIÓ</span>
            <h3>Mondd el, mi a célod.</h3>
          </div>

          {state.succeeded ? (
            <div className="form-success" role="status">
              <CheckCircle2 size={22} />

              <div>
                <strong>Köszönöm a jelentkezésed!</strong>

                <p>
                  Az üzeneted sikeresen megérkezett. Hamarosan felveszem
                  veled a kapcsolatot.
                </p>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-grid form-grid--two">
                <label>
                  <span>Név *</span>

                  <input
                    name="name"
                    type="text"
                    value={form.name}
                    onChange={update}
                    autoComplete="name"
                    required
                  />
                </label>

                <label>
                  <span>E-mail *</span>

                  <input
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={update}
                    autoComplete="email"
                    required
                  />

                  <ValidationError
                    prefix="E-mail"
                    field="email"
                    errors={state.errors}
                  />
                </label>
              </div>

              <div className="form-grid form-grid--two">
                <label>
                  <span>Telefonszám</span>

                  <input
                    name="phone"
                    type="tel"
                    value={form.phone}
                    onChange={update}
                    autoComplete="tel"
                  />
                </label>

                <label>
                  <span>Mi érdekel?</span>

                  <select
                    name="goal"
                    value={form.goal}
                    onChange={update}
                  >
                    <option value="Személyi edzés">
                      Személyi edzés
                    </option>

                    <option value="Online coaching">
                      Online coaching
                    </option>

                    <option value="6 hetes életmódcsomag">
                      6 hetes életmódcsomag
                    </option>

                    <option value="Még nem tudom">
                      Még nem tudom
                    </option>
                  </select>
                </label>
              </div>

              <label>
                <span>Röviden a célodról *</span>

                <textarea
                  name="message"
                  value={form.message}
                  onChange={update}
                  rows="5"
                  placeholder="Például: 10 kg-ot szeretnék fogyni, heti három edzés fér bele..."
                  required
                />

                <ValidationError
                  prefix="Üzenet"
                  field="message"
                  errors={state.errors}
                />
              </label>

              <label className="checkbox-label">
                <input
                  name="privacy"
                  type="checkbox"
                  value="Elfogadva"
                  checked={form.privacy}
                  onChange={update}
                  required
                />

                <span>
                  Elolvastam és elfogadom az adatkezelési tájékoztatót. *
                </span>
              </label>

              <ValidationError errors={state.errors} />

              <button
                className="button button--gold button--large button--full"
                type="submit"
                disabled={state.submitting}
              >
                {state.submitting
                  ? 'Küldés folyamatban...'
                  : 'Konzultációt kérek'}

                <ArrowUpRight size={19} />
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}